import React from "react";
import { motion } from "framer-motion";
import { Lock, CheckCircle, CreditCard, Shield } from "lucide-react";
import SecurityFeatureCard from "./security/SecurityFeatureCard";
import SecurityGuarantee from "./security/SecurityGuarantee";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const SecuritySection = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const sectionData = labels.menuPages?.howItWorks?.securitySection || {};
  const featuresData = sectionData.features || [];

  const icons = [
    <div className="relative flex items-center justify-center">
      <Shield className="w-8 h-8 md:w-12 md:h-12 text-blue-500" />
    </div>,
    <Lock className="w-8 h-8 md:w-12 md:h-12 text-blue-500" />,
    <CheckCircle className="w-8 h-8 md:w-12 md:h-12 text-green-500" />,
    <CreditCard className="w-8 h-8 md:w-12 md:h-12 text-purple-500" />,
  ];

  const securityFeatures = featuresData.map((feature: any, index: number) => ({
    icon: icons[index] || icons[0],
    title: feature.title || "",
    description: feature.description || "",
  }));

  return (
    <section className="py-12 md:py-20 bg-gradient-to-b from-gray-900 to-black">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12 md:mb-16"
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 md:mb-6">
            {sectionData.title || "Din Säkerhet i Fokus"}
          </h2>
          <p className="text-base md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed px-2">
            {sectionData.description ||
              "Vi använder branschens mest avancerade säkerhetslösningar för att skydda dina transaktioner och personliga uppgifter."}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-6xl mx-auto mb-12 md:mb-16">
          {securityFeatures.map((feature, index) => (
            <SecurityFeatureCard key={index} feature={feature} index={index} />
          ))}
        </div>

        <SecurityGuarantee />
      </div>
    </section>
  );
};

export default SecuritySection;
